import React from "react";
import "./footer.css"; // pastikan path sesuai

const Footer = () => {
  return (
    <footer className="footer">
      <div className="contact-bottom">
          <div className="bottom-item">
            <h4>HUBUNGI KAMI</h4>
            <p>AUTO2000 DENPASAR</p>
            <span>0812-745-594</span>
          </div>

          <div className="bottom-item">
            <h4>INFO PEMESANAN</h4>
            <p>Auto2000 Suci Toyota</p>
            <span>sucitoyota2@gmail.com</span>
          </div>

          <div className="bottom-item">
            <h4>ALAMAT</h4>
            <p>AUTO2000 DENPASAR</p>
            <span>Jl. Gatot Subroto No.99</span>
          </div>
        </div>
      <div className="container">
        <div className="social-links">
          <a href="https://www.facebook.com/profile.php?id=61585606653264" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://www.instagram.com/sucitoyota76?igsh=ZDc3N3ByY2RpanJn" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://wa.me/6281237455594" target="_blank" rel="noreferrer">Whatsapp</a>
        </div>
        <p>© 2025 Sucitoyota. All rights reserved.</p>
      </div>
    </footer>
  );
};
 
export default Footer;
